// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1054":"4e446fcf","6751":"100065f3","7572":"4e446fcf"}[chunkId] + ".chunk.css";
};